/* eslint-disable @typescript-eslint/no-var-requires */
export const hotelLogoQuery = require('./hotel-logo.gql');
